import { DefaultPassThrough } from '@primevue/core'
import {
  SelectButtonPassThroughAttributes,
  SelectButtonPassThroughMethodOptions,
  SelectButtonPassThroughOptions
} from 'primevue/selectbutton'
import type { SelectButtonDesignTokens } from '@primeuix/themes/types/selectbutton'

export const SelectButtonPassthroughConfig: DefaultPassThrough<SelectButtonPassThroughOptions> = {
  root(options: SelectButtonPassThroughMethodOptions): SelectButtonPassThroughAttributes {
    return {
      class: [
        'tw-segmented-control tw-h-9',
        'tw-grid tw-grid-flow-col tw-auto-cols-fr',
        options.props.fluid ? 'tw-w-full' : 'tw-w-max tw-max-w-full'
      ]
    }
  },
  pcToggleButton: {
    root: ({ context }: any) => ({
      class: [
        'tw-px-2 tw-py-1 tw-flex tw-items-center tw-justify-center',
        'tw-min-w-0 tw-overflow-hidden tw-relative',
        'tw-border-1',
        'tw-border-border tw-border-r-transparent',
        'first:tw-rounded-l-sm',
        'last:tw-rounded-r-sm last:tw-border-r-border',
        '[button[data-p-checked="true"]+&]:tw-border-l-transparent',
        {
          '!tw-border-interactive tw-bg-surface-highlight tw-z-10': context.active,
          'tw-z-0': !context.active
        }
      ]
    }),
    content: {
      class: 'tw-min-w-0 tw-w-full tw-overflow-hidden'
    },
    label: {
      class: [
        'tw-block tw-text-center tw-w-full',
        'tw-min-w-0 tw-overflow-hidden tw-truncate tw-whitespace-nowrap'
      ]
    }
  }
}

export const SelectButtonStyleConfig: SelectButtonDesignTokens = {
  root: {
    borderRadius: 'var(--border-radius)',
    invalidBorderColor: 'var(--border-color-critical)'
  }
}
